var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$store.state.device,attrs:{"id":"app"}},[(_vm.ready)?_c('div',{staticClass:"wrap"},[_c('transition',{attrs:{"name":""}},[_c('router-view')],1)],1):_vm._e(),(_vm.ready)?_c('Footer'):_vm._e(),_c('Confirm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }